


































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    computed: {
        _isFields() {
            return true;
        }
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class UserAdresFields extends Vue {
    @Prop(Object) value!: object
    @Prop() legend!: string
};

